<style lang="stylus">
    //Math滚动条样式

    html, body
        margin 0
        padding 0
    .math-home
        width 950px
        padding-bottom 0
        .dialog-slot
            padding 0 16px 14px 16px
        @media screen and (max-height: 768px)
            .home-body
                height 400px
                overflow-y scroll
    .vertical-center-modal
            .ivu-modal
                .ivu-modal-content
                    .ivu-modal-body
                        padding 0
</style>
<template>
    <Dialog
        class="math-home"
        :title="lang == 'zh' ? '亿图公式编辑器' : 'EdrawMath'"
        :mask="true"
        :showFooter="false"
        @ok="mathOK"
        @close="close"
        @actived="mathFocus"
        :width="'914'"
        :height="'550'"
    >
        <!-- <Modal v-model="mathName" width="300px" @on-ok="nameOk" @on-cancel="nameCancel" ok-text="确认" cancel-text="取消">
            <p>导出图片的名称：</p>
            <br>
            <Input v-model="nameValue" placeholder="请输入..." style="width: 200px" />

        </Modal> -->
        <home-body></home-body>
    </Dialog>
</template>
<script lang="ts">
    declare var EDMathImage: any;
    import { Component, Prop, Vue, Provide } from "vue-property-decorator";
    // const homeHead: any = require('./head/homeHead.vue');
    // const homeBody: any = require('./body/homeBody.vue');
    import homeHead from "./head/homeHead.vue";
    import homeBody from "./body/homeBody.vue";
    import Dialog from "../Modals/Dialog.vue";
    // import { addJs } from '@/app/utils/tool'

    @Component({
        components: {
            Dialog,
            homeHead,
            homeBody,
        },
    })
    export default class MathContent extends Vue {
        loading: boolean = true;
        mathName: boolean = false;
        nameValue: string = "EdrawMath";
        _provided: any;
        @Provide()
        EDMathUI = {
            view: "",
            uifontbold: true,
            uifontitalic: true,
            lineType: 0,
            arrType: 0,
            image: "",
        };
        // get showMath(){
        //     return this.$store.state.ui.showMath;
        // }
        // set showMath(val){
        //     if (val == true) {
        //         EDMathImage.editing = true;
        //     } else {
        //         EDMathImage.editing = false;
        //     }
        //     //console.log(`showMath ${val} ${EDMathImage.editing} `);
        //     this.$store.commit("toShow", {
        //         type: "showMath",
        //         data: val
        //     });
        // }
        mathOK() {
            // this.mathName = true;
            // if (!this.vip) {
            //     this.$openBuyPage("formulaEditor");
            //     return;
            // }
            EDMathImage.editing = true;
            this.nameOk();
        }
        nameOk() {
            let getImg = this._provided.EDMathUI.view.outputEDMathImage(this.nameValue);
            this.nameValue = "EdrawMath";
            this.close();
            this.sensors.track("insertFormulaToCanvas", {
                Catalogues: "SpecificFunctions",
            });
            if (!this.vip) {
                this.sensors.track("tryVipBenefit", {
                    Catalogues: "editFileProcess",
                    trial_vip_benefit: "formulaEditor",
                });
            }
        }
        close() {
            EDMathImage.editing = false;
            this._provided.EDMathUI.view.clear();
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
            this.$store.commit("toPalette", { type: null });
            this.$store.commit("setLayoutChild", { idx: -1 });

            this.$store.commit("setStatus", {
                type: "couldFixWindow",
                data: false,
            });
        }
        nameCancel() {
            this.nameValue = "EdrawMath";
            this.loading = false;
            this.$nextTick(() => {
                this.loading = true;
            });
        }

        mathFocus(status) {
            this._provided.EDMathUI.view.focus();
        }

        created() {
            // addJs("js/3rd/math.min.js");
        }

        mounted() {
            this.$bus.$on("mathEditor", (type) => {
                type == "ok" && this.mathOK();
            });
        }

        beforeDestroy() {
            this.$bus.$off("mathEditor");
        }
    }
</script>
